import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Flex,
  Textarea,
} from '@chakra-ui/react';

const ServiceSummaryEditModal = ({
  isOpen,
  onClose,
  serviceSummary,
  onSave,
}) => {
  const [formData, setFormData] = useState({
    date: '',
    company: '',
    provider: '',
    authorized: '',
    proof: null,
  });

  useEffect(() => {
    if (serviceSummary) {
      setFormData({
        date: serviceSummary.date || '',
        company: serviceSummary.company || '',
        provider: serviceSummary.provider || '',
        authorized: serviceSummary.authorized || '',
        proof: serviceSummary.proof || null,
      });
    }
  }, [serviceSummary]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = e => {
    setFormData({ ...formData, proof: e.target.files[0] });
  };

  const handleSubmit = () => {
    const formDataToSend = new FormData();
    const formattedDate = new Date(formData.date).toISOString();

    formDataToSend.append('date', formattedDate);
    formDataToSend.append('company', formData.company);
    formDataToSend.append('provider', formData.provider);
    formDataToSend.append('authorized', formData.authorized);

    if (formData.proof) {
      formDataToSend.append('proof', formData.proof);
    }

    onSave(formDataToSend);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Service Summary</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap={4}>
            <FormControl id="date">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Date
                </FormLabel>
                <Input
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  placeholder="Date"
                  type="date"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="company">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Company
                </FormLabel>
                <Input
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Company"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="provider">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Provider
                </FormLabel>
                <Input
                  name="provider"
                  value={formData.provider}
                  onChange={handleChange}
                  placeholder="Provider"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="authorized">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Authorized
                </FormLabel>
                <Textarea
                  name="authorized"
                  value={formData.authorized}
                  onChange={handleChange}
                  placeholder="Authorized"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="proof">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Proof
                </FormLabel>
                <Input
                  type="file"
                  name="proof"
                  onChange={handleFileChange}
                  placeholder="Upload proof"
                  accept=".pdf, .jpeg, .jpg" // Sadece PDF ve JPEG dosyalarını kabul et
                />
              </Flex>
            </FormControl>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ServiceSummaryEditModal;
